<template>
  <div>
    <div v-if="!esAdmin" class="text-center">
      <h3>DIAZ VELIZ EXPRESS</h3>
      <h4>Bienvenido!</h4>
    </div>
    <div v-else>
      <div>
        <b-input-group class="my-2">
          <b-input-group-prepend>
            <b-input-group-text>Viajes</b-input-group-text>
          </b-input-group-prepend>

          <select v-model="selViaje" class="form-control">
            <option
              v-for="v in Vigentes"
              :key="v.id"
              :value="v.id"
              v-html="v.text"
            ></option>
          </select>

          <b-input-group-append>
            <b-button-group>
              <b-button
                size="sm"
                squared
                @click="getEnvios(selViaje)"
                variant="primary"
                >Ver Envios</b-button
              >
              <addViaje></addViaje>
            </b-button-group>
          </b-input-group-append>
        </b-input-group>
      </div>

      <b-card v-if="MisEnvios.length > 0">
        <b-table
          @row-clicked="onRowClick"
          responsive="sm"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          small
          hover
          label-sort-clear=""
          label-sort-asc=""
          label-sort-desc=""
          table-variant="warning"
          head-row-variant="success"
          :items="MisEnvios"
          :fields="campos"
          bordered
        >
          <template #cell(Acciones)="row">
            <div class="botones">
              <b-button-group>
                <b-button
                  @click="preview(row.item.IdEnvio)"
                  pill
                  size="sm"
                  variant="outline-primary"
                >
                  <b-icon-receipt />
                </b-button>
                <b-button
                  v-show="!row.item.Entregado"
                  pill
                  variant="outline-danger"
                  class="mx-1 py-1"
                  size="sm"
                  @click="Entregar(row.item.IdEnvio)"
                  ><b-icon-truck
                /></b-button>
              </b-button-group>
            </div>
          </template>
        </b-table>
        <template #footer>
          <b-row>
            <b-col md="4">
              <b-input-group prepend="Envios">
                <label class="form-control" v-html="`${MisEnvios.length}`">
                </label>
              </b-input-group>
            </b-col>
            <b-col md="4">
              <b-input-group prepend="Total" append="$">
                <label class="form-control" v-html="TotalCobro"> </label>
              </b-input-group>
            </b-col>
            <b-col md="4">
              <b-input-group prepend="Peso">
                <label class="form-control" v-html="Peso"> </label>
              </b-input-group>
            </b-col>
          </b-row>
        </template>
      </b-card>
      <div v-else class="text-center">
        <b-alert :show="true">
          <b-icon-exclamation-circle-fill /> No hay informacion para
          mostrar!</b-alert
        >
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";

import addViaje from "./addViaje.vue";

if (!firebase.apps.length)
  firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();

var fecha = new Date(
  new Date().getFullYear(),
  new Date().getMonth(),
  new Date().getDate()
);
fecha.setDate(fecha.getDate() - 21);

let txtFecha = function (fecha) {
  fecha = typeof fecha == "string" ? new Date(fecha) : fecha;

  return fecha.toLocaleDateString("es-ES", { day: "numeric", month: "long" });
};

let Ahora = new Date(
  new Date().getFullYear(),
  new Date().getMonth(),
  new Date().getDate()
);
Ahora.setDate(Ahora.getDate() - 1);

export default {
  mounted() {
    this.esAdmin = this.$session.get("EsAdmin");
    let viajes = localStorage.Viajes || "[]";

    this.Viajes = JSON.parse(viajes);
    this.selViaje = this.nextViaje;
  },

  components: { addViaje },
  computed: {
    TotalCobro() {
      let rs = 0.0;

      this.MisEnvios.forEach((env) => {
        rs += parseFloat(env.Total);
      });

      return new Intl.NumberFormat("es-GT").format(rs);
    },
    Peso() {
      let rs = 0.0;

      this.MisEnvios.forEach((env) => {
        rs += parseFloat(env.Peso);
      });

      return new Intl.NumberFormat("es-GT").format(rs);
    },
    nextViaje() {
      if (this.Vigentes.length) {
        let d = this.Vigentes[0].id;
        return d;
      } else return null;
    },
    Vigentes() {
      let viajes = this.Viajes;
      if (viajes.length > 0) {
        let vig = this.Viajes.filter((item) => {
          return new Date(item.fecha) >= fecha;
        })
          .sort((a, b) => {
            return Date.parse(b.fecha) - Date.parse(a.fecha);
          })
          .map((item) => {
            return {
              id: item.id,
              text:
                item.origen +
                " &#9758; " +
                item.destino +
                ",  " +
                txtFecha(item.fecha),
              disponible: new Date(item.fecha) > Ahora,
            };
          });

        return vig;
      } else return [];
    },

    Viajar() {
      let v = this.viajar;
      return {
        origen: v.origen?.Codigo || "",
        destino: v.destino?.Codigo || "",
        fecha: v.fecha || "",
        precio: v.origen?.Precio || "",
      };
    },
    MisEnvios() {
      let v = this.Envios.map((env) => {
        return {
          IdEnvio: env.id,
          NoGuia: env.NoGuia,
          Envia: this.Clientes.filter((p) => p.id == env.Envia)[0],
          Fecha: env.Fecha.toDate().toLocaleString("es-ES"),
          Paquetes: env.Contenido.filter((c) => {
            return c.Tipo == "Paquete";
          }).length,
          Entregado: env.Entregado,
          Total: env.GranTotal,
          Peso: env.Contenido.reduce((t, c) => {
            return t + parseFloat(c.Peso);
          }, 0),
        };
      });

      return v;
    },
  },
  data() {
    return {
      esAdmin: false,
      selViaje: null,
      sortBy: "Fecha",
      sortDesc: true,
      winViaje: false,
      selEnvio: null,
      viajar: { destino: null, origen: null, fecha: null },
      Viajes: [],
      fecha: "",
      context: null,
      Envios: [],
      Clientes: null,
      campos: [
        { key: "Envia.Nombre", label: "Envia", sortable: true },
        { key: "Fecha", sortable: true },
        { key: "Acciones", sortable: false },
      ],
    };
  },
  firestore: {
    Clientes: db.collection("Cliente"),
  },

  methods: {
    Entregar(v) {
      localStorage.IdEnvio = v;
      this.$router.push("/courier/entrega");
    },
    getEnvios(viaje) {
      this.$bind("Envios", db.collection("Envios").where("Viaje", "==", viaje));
    },
    preview(envio) {
      let env = {
        ...this.Envios.filter((d) => {
          return d.id == envio;
        }),
      }[0];

      env.Remitente = this.Clientes.filter((p) => p.id == env.Envia)[0];
      env.Destinatario = this.Clientes.filter((p) => p.id == env.Recibe)[0];

      localStorage.Paquete = JSON.stringify(env);
      localStorage.Viaje = JSON.stringify(this.Viajes[0]);
      this.$router.push("/Envio" );
      
      //window.open("/Envio","_self");
    },
    Preview(envio) {
      let env = {
        ...this.Envios.filter((d) => {
          return d.id == envio;
        }),
      }[0];

      env.Remitente = this.Clientes.filter((p) => p.id == env.Envia)[0];
      env.Destinatario = this.Clientes.filter((p) => p.id == env.Recibe)[0];
   
      localStorage.Paquete = JSON.stringify(env);
      localStorage.Viaje = JSON.stringify(this.Viajes[0]);

      window.open("/Paquete");
    },
    onRowClick(v) {
      let r = v.IdEnvio;
      this.$router.push("/envio_edit/" + r);
    },
    onGuardarViaje() {
      let v = { ...this.Viajar };
      db.collection("Viaje")
        .add(v)
        .then(() => {
          this.winViaje = false;
        });
    },
  },
};
</script>
<style scoped>
.botones {
  min-width: 60px;
}
</style>
